import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'
import shallow from 'zustand/shallow'

import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { Country } from '../../../types'
import { LoadingAndErrors } from '../LoadingAndErrors'
import { ForeacastModalTabs } from './types'
import { usePyramidForecast } from '../../../graphql/pyramids/hooks/usePyramidForecast'
import { ForecastModalEmployeeFilters, ForecastModalEmployeeTable, ForecastModalHiringsContent, useForecastModalStore } from '.'
import { PyramidTabs, usePyramidsStore } from '../../../modules/pyramids/PyramidsStore'

const { TabPane } = Tabs

interface IForecastModalContentProps {
  companyId: string
  country: Country
}

export const ForecastModalContent: FC<IForecastModalContentProps> = ({ companyId, country }: IForecastModalContentProps) => {
  const { t } = useTranslation()
  const [fakeLoading, toggleFakeLoading] = useState<boolean>(true) // Workaround to compensate for atrocious performace of AntD Table...
  const activePyramidsTab = usePyramidsStore((state) => state.activeTab)
  const [activeTab, setModalData, resetStore] = useForecastModalStore(
    (state) => [state.activeTab, state.setModalData, state.resetStore],
    shallow,
  )

  const { data, loading, error } = usePyramidForecast(companyId, country)

  useEffect(() => {
    if (!!data && !!data.pyramidForecastWithFilters && !!data.employeeLevels) {
      setTimeout(() => {
        setModalData(data)
        toggleFakeLoading(false)
      }, 100)
    } else if (!!error) {
      toggleFakeLoading(false)
    }
  }, [data, error, country, setModalData])

  useEffect(() => {
    return () => {
      resetStore()
    }
  }, [resetStore])

  if (loading || fakeLoading || error || !data || !data.pyramidForecastWithFilters || !data.employeeLevels) {
    return (
      <div style={{ height: '350px' }}>
        <LoadingAndErrors
          isLoading={loading || fakeLoading}
          hasNoData={!data || !data.pyramidForecastWithFilters}
          error={error}
          showSpinner
        />
      </div>
    )
  } else {
    return (
      <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
        <TabPane key={ForeacastModalTabs.Employees}>
          <PerFlexRow direction="column">
            <PerText appearance="tile-heading">{t('pyramidsView.forecastModal.headings.activeEmployees')}</PerText>
            <PerText appearance="sidenote" fontSize="s" mt="xs">
              {t(`pyramidsView.shared.legend.${activePyramidsTab === PyramidTabs.Level ? 'infoLevel' : 'infoAge'}`)}
            </PerText>
          </PerFlexRow>
          <ForecastModalEmployeeFilters />
          <ForecastModalEmployeeTable isEmployeeLevelValidationEnabled={data.isEmployeeLevelValidationEnabled} />
        </TabPane>
        <TabPane key={ForeacastModalTabs.Hirings}>
          <PerFlexRow>
            <PerText appearance="tile-heading">{t('pyramidsView.forecastModal.headings.newHirings')}</PerText>
          </PerFlexRow>
          <ForecastModalHiringsContent />
        </TabPane>
      </Tabs>
    )
  }
}
